import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-wifiaccess-prices",
  templateUrl: "./wifi-access-prices.html",
  styleUrls: ["./wifi-access-prices.css"],
})
export class WiFiAccessPrices implements OnInit {
  activeAccordion: string | null = null;
  constructor() {}

  ngOnInit(): void {}

  // Method to toggle accordion sections
  toggleAccordion(sectionId: string): void {
    this.activeAccordion = this.activeAccordion === sectionId ? null : sectionId;
  }
}
